"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
var Storage = /** @class */ (function () {
    function Storage() {
        this.store = [];
        this.current = null;
    }
    Storage.prototype.stash = function (stats) {
        this.current = stats;
    };
    Storage.prototype.storeRawStats = function (stats) {
        this.store.push(stats);
    };
    Storage.prototype.flushRawStats = function (idToKeep) {
        if (!idToKeep) {
            this.store = [];
            return null;
        }
        var index = this.store.findIndex(function (elt) { return elt.getStatsId === idToKeep; });
        if (index > -1) {
            this.store.splice(0, index);
        }
        return this.store[0] || null;
    };
    Object.defineProperty(Storage.prototype, "referenceStats", {
        get: function () {
            return this.store[0] || null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Storage.prototype, "stashedStats", {
        get: function () {
            return this.current;
        },
        enumerable: false,
        configurable: true
    });
    Storage.prototype.reset = function () {
        this.store = [];
    };
    Storage.prototype.pickupNewReference = function () {
        // Return the new reference to use and remove it from the storage (avoid spike)
        return this.store.shift();
    };
    // Regenerate a new buffer starting from the first item.
    Storage.prototype.rewriteBuffer = function (referenceStats) {
        var buffer = [];
        // First stat: Diff (reference)
        var old = (0, utils_1.subtractNailUpReferenceStats)(referenceStats, this.store[0]);
        buffer.push(old);
        // For all other stats: Diff (reference) and compressed
        for (var i = 1; i < this.store.length; i++) {
            var current = (0, utils_1.subtractNailUpReferenceStats)(referenceStats, this.store[i]);
            buffer.push((0, utils_1.deltaCompression)(old, current));
            old = current;
        }
        return buffer;
    };
    return Storage;
}());
exports.default = Storage;
